export default __webpack_public_path__ + "static/media/dev.04b7859b.svg";